export enum Status {
  None = 'None',
  Loading = 'Loading',
  Successful = 'Successful',
  Failed = 'Failed',
}

export const LoadingStatuses = [Status.Loading, Status.None];
